const LogisticsHero = () => {
  return (
    <section className="bg-gradient-to-br from-[#1A3A5C] to-[#2A4A6C] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-6">
            1039 市场采购贸易 · 已验证的物流与仓储资源
          </h1>
          <p className="text-xl text-white/90 mb-4">
            覆盖广州口岸，适配批发市场、多主体货源及无进项出口场景
          </p>
          <div className="bg-white/10 rounded-lg p-6 mt-8">
            <p className="text-white/80 text-base">
              把"有资源"升级为"可用于1039的资源"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticsHero;